<template>
    <dd-card id="email-view" :class="{loaded: !loadingContent, 'flex-stretch': true}" wide-content>
        <div  class="flex-col flex-stretch width-stretch">

          <div class="pb-xs">
            <div v-if="firstSelectedEmail" class="email-info flex-row container-md">
                <div class="flex-row align-items-start p-0 pr-md" @click="goBack">
                  <dd-rounded-button icon="mdi mdi-arrow-left" style="margin-top: -5px"></dd-rounded-button>
                </div>
                <dd-avatar
                    v-if="firstSelectedEmail.customer_id"
                    class="mr-md"
                    :size="80"
                    :customer-id="firstSelectedEmail.customer_id"
                    link-to-customer
                />
                <div class="flex-col gap-xxs" style="min-width: 0">
                  <h2 class="subject-text m-0">{{ firstSelectedEmail.subject }}</h2>
                  <div v-if="hasCustomer" class="flex-row align-items-end gap-xxs">
                    <p class="color-black m-0">van: </p>
                    <p class="color-black m-0">&lt;{{firstSelectedEmail.from}}&gt;</p>
                  </div>
                  <p v-else class="color-black m-0">van: {{ firstSelectedEmail.from }}</p>
                  <p class="color-black m-0">aan: {{ firstSelectedEmail.to }}</p>
                  <p v-if="firstSelectedEmail.cc" class="color-black m-0">cc: {{ firstSelectedEmail.cc }}</p>
                  <p v-if="firstSelectedEmail.bcc" class="color-black m-0">cc: {{ firstSelectedEmail.bcc }}</p>
                  <div class="flex-row align-items-end gap-xxs">
                    <p class="color-black m-0">{{ firstSelectedEmail.sent ? 'verzonden' : 'ontvangen' }} op: </p>
                    <p class="color-black m-0">{{formattedDate}}</p>
                  </div>
                </div>
                <div class="flex-stretch flex-col align-items-end gap-sm">
                  <ViewActions :email="firstSelectedEmail"></ViewActions>
                  <EmailEventComponent/>
                </div>
            </div>

            <AttachmentsComponent/>
          </div>

          <div ref="frameContainer" class="width-stretch flex-col flex-stretch">
            <iframe
              id="frame"
              ref="frame"
              :style="{pointerEvents: this.dragging ? 'none' : 'auto'}"
              class="width-stretch flex-stretch"
            />
          </div>

        </div>
    </dd-card>
</template>

<script>
import moment from 'moment';
import DateFormatEnum from '~/enums/DateFormatEnum'
import CustomerUtils from '~/util/customer';
import ViewActions from "./email_action_buttons/ViewActions.vue";
import EmailEventComponent from './EmailEventsComponent.vue';
import AttachmentsComponent from "./AttachmentsComponent.vue";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "EmailViewComponent.vue",
  components: {
    EmailEventComponent,
    AttachmentsComponent,
    ViewActions
  },
  props:{
    dragging: {
      type: Boolean,
      required: false
    }
  },
  data(){
    return {
      loadingContent: true
    }
  },
  mounted(){
    if (this.firstSelectedEmail){
      this.silentlyReplaceIframeSrc();
      this.loadingContent = false;
    }
  },
  methods:{
    ...mapActions('email', [
      'setSelectedEmail',
      'setSendState',
      'goBack'
    ]),
    silentlyReplaceIframeSrc(){
      if (!this.firstSelectedEmail) return;

      this.$refs.frameContainer.removeChild( this.$refs.frame );
      this.$refs.frame.src = `/email/${this.firstSelectedEmail.id}/iframe`;
      this.$refs.frameContainer.appendChild( this.$refs.frame );
    },
  },
  computed: {
    ...mapGetters('email', [
      'firstSelectedEmail'
    ]),
    hasCustomer(){
      return this.firstSelectedEmail.customer_id !== null && this.firstSelectedEmail.customer?.data !== null;
    },
    customer(){
      return this.firstSelectedEmail.customer.data;
    },
    customerName(){
      return CustomerUtils.getFullName(this.customer);
    },
    customerDashboardURI () {
      return '/customer/' + this.customer.id + '/dashboard'
    },
    formattedDate(){
      return moment(this.firstSelectedEmail.date).format(DateFormatEnum.NEW_DISPLAY_DATETIME);
    }
  },
  watch:{
    firstSelectedEmail(){
      this.loadingContent = true;
      this.silentlyReplaceIframeSrc();
      this.loadingContent = false;
    }
  }
}

</script>

<style lang="scss" scoped>
@import "~@/_default.scss";
.email-info{
  width: 100%;
  min-height: fit-content;
}
iframe{
  border: none;
}
a{
    text-decoration: underline;
    text-decoration-color: $color-black;
}
.subject-text{
  width: auto;
  word-break: break-word;
  overflow: hidden;
  padding-right: $spacing-md;
}
.subject-text:first-letter {
    text-transform: uppercase;
}
</style>
